import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import PasswordInput from "../../components/PasswordInput";
import Button from "../../components/Button";
import styles from "./styles.css";
import ScreenContainer from "../../components/ScreenContainer";
import Header from "../../components/Header";
import Note from "../../components/Note";
import { typography } from "../../styles/typography";
import colors from "../../styles/colors";
import EditDoc from "./images/EditDoc";
import TrendUp from "./images/TrendUp";
import AddChart from "./images/AddChart";
import Moon from "./images/Moon";
import Arrow from "./images/Arrow";
import Eye from "./images/Eye";
import Glasses from "./images/Glasses";
import Footer from "../../components/Footer";
import { useSessionCheck } from "../../hooks/useSessionCheck";
import { t } from "i18next";
import { BACKEND_URL } from "../../services/contants";
import { getCurrentUser } from "../../services/auth";
import { useAppContext } from "../../store/AppContext";

const PlanIntroUpdate = () => {
  //useSessionCheck()
  const {state} = useAppContext()
  const user = state.user
  const navigate = useNavigate();
  const [isBtnVisible, setBtnVisible] = useState(false)

  const handleScroll = () => {
    //window.alert("scroll!")
    setBtnVisible(true)
  }
  const handleConfirm = async () => {
    const token = await getCurrentUser().getIdToken(true);
    const res = await fetch(`${BACKEND_URL}/${user.subscription.provider}/cancel-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}` // Attach token here
      },
      body: JSON.stringify({
        user: getCurrentUser()
      })
    });
    navigate("/plan_change_complete")
  };

  function trans(key) {
    return t("cancel_confirmation_" + key)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer} onScroll={handleScroll}>

        <h1 className={"title title_m_24_medium"} style={{ textAlign: 'center' }}>{trans(157)}</h1>
        <p className={"description body_15_regular mt-16"}>
          {trans(158)}
        </p>

        <div style={{ ...style.section, marginTop: 62 }}>
          {/* <label style={{ ...style.tag, maxLines: 1 }}>{trans(40)}</label> */}
          <div className="mt-56">
            <div style={style.subtitle}>{trans(159)}</div>
          </div>
          <div style={style.subsubtitle} className="mt-8">{trans(160)}</div>
          <div className="mt-40" />
          <Content
            icon={<TrendUp />}
            title={trans(161)}
            description={trans(162)}
          />
          <Content
            icon={<EditDoc />}
            title={trans(163)}
            description={trans(164)}
            className={"mt-24"}
          />

          <Content
            icon={<AddChart />}
            title={trans(165)}
            description={trans(166)}
            className={"mt-24"}
          />
        </div>

        {/* <div style={style.section} className="mt-16">
          <div className="mt-56">
            <div style={{ ...style.subtitle, color: "#46CEFF" }}>{trans(50)}</div>
          </div>
          <div style={style.subsubtitle} className="mt-8">{trans(51)}</div>
          <div style={style.contentDescription}>{trans(52)}</div>
          <div className="mt-40" />
          <Content
            icon={<Moon />}
            description={trans(53)}
          />
          <Content
            icon={<Arrow />}
            description={trans(54)}
            className={"mt-24"}
          />
          <Content
            icon={<Glasses />}
            description={trans(55)}
            className={"mt-24"}
          />
        </div> */}
        <Footer style={{ marginTop: 150 }} />
      </div>
      {isBtnVisible && <div className="fixed-button-wrapper">
        <Button
          text={t("confirm")}
          onClick={handleConfirm}
          className={"primary-on-button primary-button-text"}
        />
      </div>}

    </ScreenContainer>
  );
};

const Content = ({ icon, title, description, className }) => {
  return <div style={style.content} className={className}>
    {icon}
    {title ? <div style={style.contentTitle} className="mt-16">{title}</div> : <div style={{ marginTop: 10 }} />}
    <div style={style.contentDescription}>{description}</div>
  </div>
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll',
    paddingBottom: 80
  },
  tag: {
    color: '#000',
    backgroundColor: '#56FFDA',
    ...typography.body["15_medium"],
    position: 'absoulte',
    marginTop: -14,
    height: 28,
    padding: "3px 16px",
    borderRadius: 14,
    lineHeight: undefined
  },
  section: {
    border: '1px #23292E solid',
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingBottom: 56
  },
  subtitle: {
    ...typography.title.m_24_medium,
    color: '#56FFDA',
  },
  subsubtitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
    padding: '0px 16px',
    textAlign: 'center'
  },
  subtag: {
    ...typography.caption_12_regular,
    color: '#fff',
    backgroundColor: colors.primaryColor800,
    borderRadius: 5,
    padding: '2px 6px',
    marginTop: 10
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 18px'

  },
  contentTitle: {
    ...typography.body["15_medium"],
    color: '#fff',
    textAlign: 'center'
  },
  contentDescription: {
    ...typography.body["15_regular"],
    color: colors.mono300,
    marginTop: 6,
    textAlign: 'center',
    paddingLeft: 18,
    paddingRight: 18,
  }
}

export default PlanIntroUpdate;
